import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const upcloud = defineConnector({
  identifier: "upcloud",
  name: "UpCloud",
  tagLine: "European cloud hosting provider",
  logo,
  protocol: "http",
  tags: ["it", "engineering"],
  defaultUrlPattern: () => "https://api\\.upcloud\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [UpCloud Control Panel](https://hub.upcloud.com/), navigate to **Account > API Tokens** and add a new API token. Copy the token when it is displayed — it is shown only once.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "UpCloud API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.upcloud.com/1.3/account",
  },
});
